import './AllBundlePacksComponent.scss';
import {CommonService} from "../../../shared/services";
import moment from "moment-timezone";

interface IAllBundlePacksProps {
    allBundlePacks: any;
}

const AllBundlePacksComponent = (props: IAllBundlePacksProps) => {
    const { allBundlePacks } = props;

    return (
        <div className="all-bundle-packs">
            <div className="facility-details-component">
                <div className={'title'}>
                    Existing Bundle Packs
                </div>
                <div className={'wrapper'}>
                    {
                        allBundlePacks?.map((bundlePack:any, index:number) => {
                            return (<div className={'facility-details-wrapper'}>
                                        <div key={index} className={'purchased-bundle-pack-item'}>
                                            <div className={'purchased-bundle-pack-item-heading mrg-top-20'}>
                                                {bundlePack.consultation_details?.title} - {bundlePack.consultation_details?.consultation_details[0]?.duration + ' minutes'}
                                            </div>
                                            <div className={'purchased-bundle-pack-item-body'}>
                                                Total Sessions: {bundlePack?.total_sessions}
                                            </div>
                                            <div className={'purchased-bundle-pack-item-body'}>
                                                Remaining Sessions: {bundlePack?.total_sessions - bundlePack?.booked_sessions}
                                            </div>
                                            <div className={'purchased-bundle-pack-item-body mrg-bottom-20'}>
                                                Expiry
                                                Date: {CommonService.getDateFromTimezone(bundlePack?.expiry_date, moment.tz.guess(), 'DD-MMM-YYYY')}
                                            </div>
                                        </div>
                            </div>

                            )
                        })
                    }
                </div>

            </div>
        </div>
    );
}

export default AllBundlePacksComponent;
